import React from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function FinalField({ finalData, setFinalData, isDisable }) {
  const handleInputChange = (field, value) => {
    setFinalData({
      ...finalData,
      [field]: value,
    });
  };

  return (
    <>
      <div className="mt-4">
        <RB.Row>
          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="usefulLife"
                label="Useful Life of the Assets"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Useful Life of the Assets"
                  disabled={isDisable}
                  type="text"
                  value={finalData.usefulLife}
                  onChange={(e) =>
                    handleInputChange("usefulLife", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="coaDescription"
                label="COA Description"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="COA Description"
                  type="text"
                  value={finalData.coaDescription}
                  onChange={(e) =>
                    handleInputChange("coaDescription", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="scheduleVIClassification"
                label="Schedule VI Classification"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Schedule VI Classification"
                  type="text"
                  value={finalData.scheduleVIClassification}
                  onChange={(e) =>
                    handleInputChange(
                      "scheduleVIClassification",
                      e.target.value
                    )
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="depreciationRate"
                label="Depreciation Rate"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Depreciation Rate"
                  type="text"
                  value={finalData.depreciationRate}
                  onChange={(e) =>
                    handleInputChange("depreciationRate", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="companiesAct"
                label="Companies Act"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Companies Act"
                  type="text"
                  value={finalData.companiesAct}
                  onChange={(e) =>
                    handleInputChange("companiesAct", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="incomeTaxAct"
                label="Income Tax Act"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Income Tax Act"
                  type="text"
                  value={finalData.incomeTaxAct}
                  onChange={(e) =>
                    handleInputChange("incomeTaxAct", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="capitalisationEntryNo"
                label="Capitalisation Entry No."
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="Capitalisation Entry No."
                  type="text"
                  value={finalData.capitalisationEntryNo}
                  onChange={(e) =>
                    handleInputChange("capitalisationEntryNo", e.target.value)
                  }
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mt-3">
              <DatePicker
                selected={finalData.capitalisationEntryDate}
                onChange={(date) =>
                  handleInputChange("capitalisationEntryDate", date)
                }
                dateFormat="dd-MM-yyyy"
                className="form-control"
                placeholderText="Select Capitalisation Date"
              />
            </div>
          </RB.Col>

          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="farSerialNo"
                label="FAR Serial No."
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  placeholder="FAR Serial No."
                  type="text"
                  value={finalData.farSerialNo}
                  onChange={(e) =>
                    handleInputChange("farSerialNo", e.target.value)
                  }
                  required
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>
        </RB.Row>
      </div>
    </>
  );
}

export default FinalField;
